//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../no/Annotations.js";
import "../Annotations/Annotations.AnnotationManager.js";
let d=[[],[[[],"GetLetteringPreferences",{R_:{lettering_prefs:"Annotations.LetteringPreferences"}},0,0],[[],"GetLineAndArrowPreferences",{R_:{prefs:"Annotations.LineAndArrowPreferences"}},0,0],[[],"GetSymbolPreferences",{R_:{prefs:"Annotations.SymbolPreferences"}},0,0],[[],"GetDimensionPreferences",{R_:{prefs:"Annotations.DimensionPreferences"}},0,0],[[],"GetAngularTolerances",{R_:{prefs:"Annotations.AngularTolerance"}},0,0],[[],"GetLinearTolerances",{R_:{prefs:"Annotations.LinearTolerance"}},0,0],[[],"GetPmiPreferences",{R_:{pmi_prefs:"Annotations.PmiPreferences"}},0,1],[[],"GetNxFontCharacterSpaceFactor",{R_:{nx_font_character_space_factor:''}},0,0],[[],"GetStandardFontCharacterSpaceFactor",{R_:{standard_font_character_space_factor:''}},0,0],[[],"GetFrameBarPreferences",{R_:{frame_bar_prefs:"Annotations.FrameBarPreferences"}},0,0],[["lettering_prefs"],"SetLetteringPreferences",{},1,0],[["prefs"],"SetLineAndArrowPreferences",{},1,0],[["prefs"],"SetSymbolPreferences",{},1,0],[["prefs"],"SetDimensionPreferences",{},1,0],[["prefs"],"SetAngularTolerances",{},1,0],[["prefs"],"SetLinearTolerances",{},1,0],[["pmi_prefs"],"SetPmiPreferences",{},1,0],[["nx_font_character_space_factor"],"SetNxFontCharacterSpaceFactor",{},1,0],[["standard_font_character_space_factor"],"SetStandardFontCharacterSpaceFactor",{},1,0],[["frame_bar_prefs"],"SetFrameBarPreferences",{},1,0]],[]];
SPLM.Preferences.AnnotationPreferences = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.AnnotationPreferences";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;